import { Box, Typography } from '@mui/material';
import passGemsIconSrc from '../../assets/bazzar/pass-gems-icon.png';
import passKnowMoreInfoIconSrc from '../../assets/bazzar/pass-know-more-info-icon.png';
import rapcoinKnowBarIconSrc from '../../assets/bazzar/rapcoin-know-bar-icon.png';
import vipRoomKnowBarIconSrc from '../../assets/bazzar/vip-room-know-bar-icon.png';

const BAR_HEIGHT = 54;
const KNOW_MORE_PILL_WIDTH = 111.89;
const KNOW_MORE_PILL_HEIGHT = 25.89;
const LEFT_GEM_WIDTH = 27.55;
const LEFT_GEM_HEIGHT = 28;
const LEFT_RAPCOIN_WIDTH = 28;
const LEFT_RAPCOIN_HEIGHT = 28;
const LEFT_VIP_ROOM_WIDTH = 27.86;
const LEFT_VIP_ROOM_HEIGHT = 28;

const VARIANTS = {
  passes: {
    ariaLabel: 'Know More about Passes',
    promoText: 'Passes gives more access',
    promoWhiteSpace: 'nowrap',
    promoMaxWidth: undefined,
  },
  rapcoin: {
    ariaLabel: 'Know More about RapCoins',
    promoText: 'RapCoins let you unlock entry to play the games',
    promoWhiteSpace: 'normal',
    promoMaxWidth: 204,
  },
  rapgem: {
    ariaLabel: 'Know More about RapGems',
    promoText: 'Push beyond your limits with RapGems.',
    promoWhiteSpace: 'normal',
    promoMaxWidth: 204,
  },
  'vip-room': {
    ariaLabel: 'Know More about VIP Room',
    promoText: 'Room Unlock private space to have fun',
    promoWhiteSpace: 'normal',
    promoMaxWidth: 204,
  },
};

/** Figma 10933:3658 */
function PassGemsIcon() {
  return (
    <Box
      sx={{
        width: LEFT_GEM_WIDTH,
        height: LEFT_GEM_HEIGHT,
        overflow: 'hidden',
        flexShrink: 0,
        position: 'relative',
      }}
    >
      <Box
        component="img"
        src={passGemsIconSrc}
        alt=""
        aria-hidden="true"
        sx={{
          position: 'absolute',
          width: '97.84%',
          height: '96.77%',
          maxWidth: 'none',
          left: '0.26%',
          top: '1.61%',
          display: 'block',
        }}
      />
    </Box>
  );
}

/** Figma 10934:12842 */
function RapCoinIcon() {
  return (
    <Box
      sx={{
        width: LEFT_RAPCOIN_WIDTH,
        height: LEFT_RAPCOIN_HEIGHT,
        overflow: 'hidden',
        flexShrink: 0,
        position: 'relative',
      }}
    >
      <Box
        component="img"
        src={rapcoinKnowBarIconSrc}
        alt=""
        aria-hidden="true"
        sx={{
          position: 'absolute',
          width: '111.75%',
          height: '169.72%',
          maxWidth: 'none',
          left: '-5.33%',
          top: '-34.14%',
          display: 'block',
        }}
      />
    </Box>
  );
}

/** Figma 10934:12820 */
function VipRoomIcon() {
  return (
    <Box
      sx={{
        width: LEFT_VIP_ROOM_WIDTH,
        height: LEFT_VIP_ROOM_HEIGHT,
        overflow: 'hidden',
        flexShrink: 0,
        position: 'relative',
      }}
    >
      <Box
        component="img"
        src={vipRoomKnowBarIconSrc}
        alt=""
        aria-hidden="true"
        sx={{
          position: 'absolute',
          width: '132.99%',
          height: '132.3%',
          maxWidth: 'none',
          left: '-17.53%',
          top: '-10.85%',
          display: 'block',
        }}
      />
    </Box>
  );
}

/** Figma 11207:2318 */
function KnowMoreInfoIcon() {
  return (
    <Box
      sx={{
        width: 15,
        height: 15,
        flexShrink: 0,
        borderRadius: '50%',
        bgcolor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src={passKnowMoreInfoIconSrc}
        alt=""
        aria-hidden="true"
        sx={{
          width: 18.633,
          height: 18.633,
          display: 'block',
        }}
      />
    </Box>
  );
}

function LeftIconForVariant({ variant }) {
  if (variant === 'rapcoin') return <RapCoinIcon />;
  if (variant === 'vip-room') return <VipRoomIcon />;
  return <PassGemsIcon />;
}

/** Figma 11207:2311 / 11207:1937 / 11207:1957 / 11207:1977 + know-more pill */
export default function PassKnowMoreBar({ variant = 'passes', onKnowMoreClick }) {
  const config = VARIANTS[variant] || VARIANTS.passes;

  return (
    <Box
      component="button"
      type="button"
      onClick={onKnowMoreClick}
      aria-label={config.ariaLabel}
      sx={{
        position: 'relative',
        width: { xs: '100%', md: '100%' },
        maxWidth: 400,
        height: BAR_HEIGHT,
        mx: 'auto',
        overflow: 'hidden',
        border: 0,
        bgcolor: 'transparent',
        p: 0,
        display: 'block',
        cursor: onKnowMoreClick ? 'pointer' : 'default',
        textAlign: 'left',
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          borderRadius: '12px',
          border: '0.4px solid #fff5a7',
          background: 'linear-gradient(229.92deg, #fff04b 0%, #f30000 99.88%)',
          boxShadow: 'inset -2px -2px 15px rgba(98, 0, 82, 0.5)',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          pl: '13.77px',
          pr: '7px',
          gap: '12px',
        }}
      >
        <LeftIconForVariant variant={variant} />
        <Typography
          component="span"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: 14,
            lineHeight: '20px',
            letterSpacing: '0.5px',
            color: '#fff',
            whiteSpace: config.promoWhiteSpace,
            flexShrink: 1,
            minWidth: 0,
            maxWidth: config.promoMaxWidth,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {config.promoText}
        </Typography>

        <Box
          aria-hidden
          sx={{
            flexShrink: 0,
            ml: 'auto',
            width: KNOW_MORE_PILL_WIDTH,
            height: KNOW_MORE_PILL_HEIGHT,
            borderRadius: '100px',
            border: '2px dashed #ff00f2',
            bgcolor: 'rgba(19, 0, 53, 0.7)',
            boxShadow: 'inset 0 0 8px rgba(0, 0, 0, 0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '7px',
            px: '7px',
            color: '#ff00f2',
            pointerEvents: 'none',
          }}
        >
          <KnowMoreInfoIcon />
          <Typography
            component="span"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: 12,
              lineHeight: '20px',
              letterSpacing: '0.8px',
              color: '#ff00f2',
              whiteSpace: 'nowrap',
            }}
          >
            Know More
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
